import { useEffect, useRef, useState } from "react";
import { Steps } from "primereact/steps";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import UserService from "../../../api/UserService";
import BranchService from "../../../api/BranchService";
import useAuth from "../../../hooks/useAuth";
import RequirementService from "../../../api/RequirementService";
import GeneralTestService from "../../../api/GeneralTestService";
import { SelectButton } from "primereact/selectbutton";
import RequirementSubmissionService from "../../../api/RequirementSubmissionService";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routes";
import { RadioButton } from "primereact/radiobutton";
import TestSubmissionService from "../../../api/TestSubmissionService";

const Application = () => {
  const { auth } = useAuth();
  const [user, setUser] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(true);
  const toast = useRef(null);
  const navigate = useNavigate();
  const items = [
    {
      label: "Parcours",
      command: (event) => {
        handleStepClick(event.index, event.item);
      },
    },
    {
      label: "Test d'Admission",
      command: (event) => {
        handleStepClick(event.index, event.item);
      },
    },
    {
      label: "Candidature",
      command: (event) => {
        handleStepClick(event.index, event.item);
      },
    },
    {
      label: "Développement Personnel",
      command: (event) => {
        handleStepClick(event.index, event.item);
      },
    },
  ];
  const handleStepClick = (index, item) => {
    if (index < activeStep) {
      toast.current.show({
        severity: "warn",
        summary: "Attention !",
        detail: "Impossible d'aller derrière",
      });
    } else {
      toast.current.show({
        severity: "warn",
        summary: "Attention !",
        detail: "Veuillez suivre toutes les étapes svp !",
      });
    }
  };
  const [selectedSexe, setSelectedSexe] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedFormation, setSelectedFormation] = useState({ id: 1 });
  const [requirements, setRequirements] = useState([]);
  const [selectedRequirements, setSelectedRequirements] = useState([]);
  const [generalTests, setGeneralTests] = useState([]);
  const [generalTestAnswers, setGeneralTestAnswers] = useState([]);
  const sexes = [
    { name: "Masculin", code: "0" },
    { name: "Féminin", code: "1" },
    { name: "Autre", code: "2" },
  ];

  const options = ["Non", "Oui"];
  const [value, setValue] = useState(options[0]);

  const [formations, setFormations] = useState([]);

  const [sites, setSites] = useState([]);

  const schema = Yup.object({
    firstname: Yup.string()
      .required("Le prénom est obligatoire")
      .min(3, "Trop court")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Uniquement des lettres svp !"
      ),
    lastname: Yup.string()
      .required("Le nom est obligatoire")
      .min(3, "Trop court")
      .matches(
        /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
        "Uniquement des lettres svp !"
      ),
    email: Yup.string()
      .required("L'email est obligatoire")
      .email("Email invalide"),
    phone: Yup.number().required("Le numero de téléphone est obligatoire"),
    birthday: Yup.date()
      .required("La date de naissance est obligatoire")
      .max(
        new Date(new Date().setFullYear(new Date().getFullYear() - 17)),
        "Vous devriez avoir au moins 17 ans"
      ),
    profession: Yup.string().required("La profession est obligatoire"),
    matrimonial_situation: Yup.string().required(
      "Situation matrimoniale obligatoire"
    ),
    gender: Yup.string().required("Le genre est obligatoire"),
    nationality: Yup.string().required("La nationalité est obligatoire"),
    address: Yup.string().required("L'adresse est obligatoire"),
    level: Yup.string().required("Le niveau d'étude est obligatoire"),
    lastDiploma: Yup.string().required("Le niveau d'étude est obligatoire"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const updateUserData = (data) => {
    console.log("data");
    data.gender =
      data.gender == "Masculin" ? 0 : data.gender == "Féminin" ? 1 : 2;
    console.log("data", data);
    data.birthday = new Date(data.birthday).toISOString().split("T")[0];

    UserService.update(user?.id, data)
      .then((res) => {
        console.log("res", res);
        /* toast.current.show({
            severity: "success",
            summary: "Succès",
            detail: "Formulaire soumis avec succès. Passez à l'étape suivante",
            life: 1500,
          }); */
        moveToNextStep();
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
        toast.current.show({
          severity: "danger",
          summary: "Erreur",
          detail: "Formulaire soumis avec succès. Passez à l'étape suivante",
          life: 1500,
        });
        setLoading(false);
      });
    /* setTimeout(() => {
        toast.current.show({
          severity: "success",
          summary: "Succès",
          detail: "Formulaire soumis avec succès. Passez à l'étape suivante",
          life: 1500,
        });
        setActiveStep((step) => step + 1);
        setLoading(false);
      }, 2000); */
  };

  const moveToNextStep = () => {
    setActiveStep((prevStep) => {
      return prevStep + 1;
    });
  };

  useEffect(() => {
    setLoading(true);
    BranchService.getPublicAll().then((res) => {
      console.log("res", res);
      setSites(res.data.branches);
    });
    setUser(auth?.user);
    RequirementService.getByTraining(selectedFormation?.id).then((res) => {
      setRequirements(res.data.requirements);
      if (generalTests.length > 0) {
        setLoading(false);
      }
    });
    GeneralTestService.getByTraining(selectedFormation?.id).then((res) => {
      setGeneralTests(res.data.generalTests);
      if (requirements.length > 0) {
        setLoading(false);
      }
    });
    setLoading(false);
  }, [selectedFormation]);

  console.log("id", selectedFormation.id);

  const handleStepOne = (e) => {
    setLoading(true);
    e.preventDefault();
    setTimeout(() => {
      moveToNextStep();
      setLoading(false);
    }, 2000);
  };

  const handleRequirement = (id, answer) => {
    let newReq = [];
    const reqAnswerData = {
      id: id,
      answer: answer,
    };
    if (selectedRequirements.filter((selReq) => selReq.id == id).length > 0) {
      newReq = selectedRequirements.filter((selReq) => selReq.id != id);
      newReq.push(reqAnswerData);
      setSelectedRequirements(newReq);
    } else {
      newReq = selectedRequirements;
      newReq.push(reqAnswerData);
      setSelectedRequirements(newReq);
    }
    console.log("new", newReq);
  };
  const handleSubmitRequirement = (e) => {
    e.preventDefault();
    setLoading(true);
    if (selectedRequirements.length != requirements.length) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Stop",
        detail: "Veuillez répondre à toutes les questions",
        life: 3000,
      });
    } else {
      const data = {
        content: selectedRequirements,
        training_program_id: selectedFormation.id,
      };
      RequirementSubmissionService.create(data)
        .then((res) => {
          console.log("res", res);
          if (res.data.success == true) {
            moveToNextStep();
          } else {
            toast.current.show({
              severity: "error",
              summary: "Stop",
              detail:
                "Vous ne pouviez pas candidater pour ce parcours maintenant. Veuillez réessayer dans 3 mois",
              life: 3000,
              onclose: () => {
                navigate(routes.home);
              },
              onclick: () => {
                navigate(routes.home);
              },
            });
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Stop",
            detail:
              "Vous ne pouviez pas candidater pour ce parcours maintenant. Veuillez réessayer dans 3 mois",
            life: 3000,
            onclose: () => {
              navigate(routes.home);
            },
            onclick: () => {
              navigate(routes.home);
            },
          });
        });
    }
  };

  const handleTest = (id, answerId) => {
    let newReq = [];
    const testAnswerData = {
      id: id,
      answerId: answerId,
    };
    if (generalTestAnswers.filter((selReq) => selReq.id == id).length > 0) {
      newReq = generalTestAnswers.filter((selReq) => selReq.id != id);
      newReq.push(testAnswerData);
      setSelectedRequirements(newReq);
    } else {
      newReq = generalTestAnswers;
      newReq.push(testAnswerData);
      setSelectedRequirements(newReq);
    }
    console.log("new", newReq);
  };

  const handleSubmitTest = (e) => {
    e.preventDefault();
    setLoading(true);
    if (generalTestAnswers.length != generalTests.length) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Stop",
        detail: "Veuillez répondre à toutes les questions",
        life: 3000,
      });
    } else {
      const data = {
        content: generalTestAnswers,
        training_program_id: selectedFormation.id,
        branche_id: selectedSite.id,
      };
      TestSubmissionService.create(data)
        .then((res) => {
          console.log("res", res);
          if (res.data.success == true) {
            toast.current.show({
              severity: "success",
              summary: "Succès",
              detail:
                "Bravo. Vous aviez réussi le test developpement. Votre dossier sera traité dans les brèves délais",
              life: 3000,
              onclose: () => {
                navigate(routes.dashboard.mycandidates);
              },
              onclick: () => {
                navigate(routes.dashboard.mycandidates);
              },
            });
            setTimeout(() => {
              navigate(routes.dashboard.mycandidates);
            }, 3000);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Stop",
              detail:
                "Vous n'aviez pas réussi au test. Veuillez réessayer dans 3 mois",
              life: 3000,
              onclose: () => {
                navigate(routes.home);
              },
              onclick: () => {
                navigate(routes.home);
              },
            });
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Stop",
            detail:
              "Vous ne pouviez pas candidater pour ce parcours maintenant. Veuillez réessayer dans 3 mois",
            life: 3000,
            onclose: () => {
              navigate(routes.dashboard.mycandidates);
            },
            onclick: () => {
              navigate(routes.dashboard.mycandidates);
            },
          });
        });
    }
  };

  return (
    <div className="application_container">
      <Toast ref={toast}></Toast>
      <div>
        <Steps
          model={items}
          activeIndex={activeStep}
          //onSelect={(e) => setActiveStep(e.index)}
          readOnly={true}
        />
      </div>
      <div className="application_wraper">
        <div className="application_content">
          {loading ? (
            <div
              className="step_form_container"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ProgressSpinner
                style={{ width: "20px", height: "20px" }}
                strokeWidth="8"
                loading={loading}
              />
            </div>
          ) : activeStep == 0 ? (
            <div className="step_form_container">
              <div className="step_form_wraper">
                <form className="form_wraper" onSubmit={handleStepOne}>
                  <div className="form__item">
                    <label htmlFor="site">Site</label>
                    <div className="form__item__ic_p">
                      <Dropdown
                        value={selectedSite}
                        onChange={(e) => {
                          console.log(e.value.training_programs, "e");
                          setSelectedSite(e.value);
                          setFormations(e.value.training_programs);
                        }}
                        options={sites}
                        optionLabel="name"
                        placeholder="Sectionner un site"
                        className="w-full"
                      />
                    </div>
                    <ErrorMsg>{errors.sexe?.message}</ErrorMsg>
                  </div>
                  {formations.length > 0 && (
                    <div className="form__item">
                      <label htmlFor="formation">Parcours</label>
                      <div className="form__item__ic_p">
                        <Dropdown
                          value={selectedFormation}
                          onChange={(e) => setSelectedFormation(e.value)}
                          options={formations}
                          optionLabel="name"
                          placeholder="Sectionner un parcours"
                          className="w-full"
                        />
                      </div>
                      <ErrorMsg>{errors.sexe?.message}</ErrorMsg>
                    </div>
                  )}
                  <div className="form__item">
                    <button type="submit">
                      Suivant{" "}
                      <ProgressSpinner
                        style={
                          loading
                            ? { width: "20px", height: "20px" }
                            : { width: "0px", height: "0px" }
                        }
                        strokeWidth="8"
                        loading={loading}
                      />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          ) : activeStep == 1 ? (
            <div className="step_form_container">
              <div className="step_form_wraper">
                <form
                  className="form_wraper"
                  onSubmit={handleSubmitRequirement}
                >
                  <div>
                    {requirements.map((req, index) => (
                      <div
                        key={index}
                        className=" flex justify-content-between align-items-center my-2"
                      >
                        <div>{req.requirement}</div>
                        <div className="card flex justify-content-center">
                          <SelectButton
                            value={
                              selectedRequirements.filter(
                                (selReq) => selReq.id == req.id
                              )[0]?.answer == 1
                                ? "Oui"
                                : selectedRequirements.filter(
                                    (selReq) => selReq.id == req.id
                                  )[0]?.answer == 0
                                ? "Non"
                                : null
                            }
                            onChange={(e) => {
                              //console.log("e...", e.target.value)
                              if (e.target.value == "Oui") {
                                handleRequirement(req.id, 1);
                              } else {
                                handleRequirement(req.id, 0);
                              }
                            }}
                            options={options}
                            id={index}
                            //name={`req-${index}`}
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="form__item flex justify-content-center w-full">
                    <button type="submit" disabled={loading}>
                      Suivant{" "}
                      <ProgressSpinner
                        style={
                          loading
                            ? { width: "20px", height: "20px" }
                            : { width: "0px", height: "0px" }
                        }
                        strokeWidth="8"
                        loading={loading}
                      />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          ) : activeStep == 2 ? (
            <div className="step_form_container">
              <div className="step_form_wraper">
                <form className="" onSubmit={handleSubmit(updateUserData)}>
                  <div className="step_form">
                    <div className="form__item">
                      <label htmlFor="lastname">Nom</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="lastname"
                          label="lastname"
                          register={register}
                          defaultValue={user?.lastname}
                        />
                      </div>
                      <ErrorMsg>{errors.lastname?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="firstname">Prénom(s)</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="firstname"
                          label="firstname"
                          register={register}
                          defaultValue={user?.firstname}
                        />
                      </div>
                      <ErrorMsg>{errors.firstname?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="Email">Email</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          type="email"
                          name="email"
                          label="email"
                          defaultValue={user?.email}
                          register={register}
                        />
                      </div>
                      <ErrorMsg>{errors.email?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="phone">Téléphone</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          type="number"
                          minLength={8}
                          name="phone"
                          label="phone"
                          defaultValue={user?.phone}
                          register={register}
                        />
                      </div>
                      <ErrorMsg>{errors.phone?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="Sexe">Sexe</label>
                      <div className="form__item__ic_p">
                        <Dropdown
                          value={selectedSexe}
                          {...register("gender")}
                          defaultValue={user?.gender}
                          id={"gender"}
                          //value={register("gender")}
                          onChange={(e) => {
                            setSelectedSexe(e.value);
                          }}
                          options={sexes}
                          optionLabel="name"
                          placeholder="Sectionner un sexe"
                          className="w-full"
                        />
                      </div>
                      <ErrorMsg>{errors.gender?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="nationality">Nationalité</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="nationality"
                          defaultValue={user?.nationality}
                          label="nationality"
                          register={register}
                        />
                      </div>
                      <ErrorMsg>{errors.nationality?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="birthday">Date de naissance</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="birthday"
                          label="birthday"
                          type="date"
                          defaultValue={user?.birthday}
                          register={register}
                        />
                      </div>
                      <ErrorMsg>{errors.birthday?.message}</ErrorMsg>
                    </div>

                    <div className="form__item">
                      <label htmlFor="matrimonial_situation">
                        Situation matrimoniale
                      </label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="matrimonial_situation"
                          label="matrimonial_situation"
                          defaultValue={user?.matrimonial_situation}
                          register={register}
                        />
                      </div>
                      <ErrorMsg>
                        {errors.matrimonial_situation?.message}
                      </ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="profession">Profession</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="profession"
                          label="profession"
                          defaultValue={user?.profession}
                          register={register}
                        />
                      </div>
                      <ErrorMsg>{errors.profession?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="address">Adresse</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="address"
                          label="address"
                          defaultValue={user?.address}
                          register={register}
                        />
                      </div>
                      <ErrorMsg>{errors.address?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="level">Niveau d'étude</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="level"
                          defaultValue={user?.level}
                          label="level"
                          register={register}
                        />
                      </div>
                      <ErrorMsg>{errors.level?.message}</ErrorMsg>
                    </div>
                    <div className="form__item">
                      <label htmlFor="level">Dernier diplôme obtenu</label>
                      <div className="form__item__ic_p">
                        <TextInput
                          name="lastDiploma"
                          defaultValue={user?.lastDiploma}
                          label="lastDiploma"
                          register={register}
                        />
                      </div>
                      <ErrorMsg>{errors.lastDiploma?.message}</ErrorMsg>
                    </div>
                  </div>
                  <div className="form__item flex justify-content-center w-full">
                    <button type="submit">
                      Suivant{" "}
                      <ProgressSpinner
                        style={
                          loading
                            ? { width: "20px", height: "20px" }
                            : { width: "0px", height: "0px" }
                        }
                        strokeWidth="8"
                        loading={loading}
                      />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          ) : (
            <div className="step_form_container">
              <div className="step_form_wraper">
                <form className="form_wraper" onSubmit={handleSubmitTest}>
                  <div>
                    {generalTests.map((test, index) => (
                      <div
                        key={index}
                        className=" justify-content-between align-items-center my-4"
                      >
                        <div className="mb-3">{test.test}</div>

                        {test?.test_proposals?.length > 0 &&
                          test?.test_proposals.map((prop, propIndex) => (
                            <div
                              className="flex align-items-center mb-2"
                              key={propIndex}
                            >
                              <RadioButton
                                inputId={`proposal-${index}-${propIndex}`}
                                name={`proposal${propIndex}`}
                                value={prop.id}
                                checked={
                                  generalTestAnswers.filter(
                                    (selReq) =>
                                      selReq.id == test.id &&
                                      selReq.answerId == prop.id
                                  ).length > 0
                                }
                                onChange={(e) => {
                                  handleTest(test.id, prop.id);
                                }}
                                //onChange={(e) => setIngredient(e.value)}
                                //checked={ingredient === "Cheese"}
                              />
                              <label
                                htmlFor={`proposal-${index}-${propIndex}`}
                                className="ml-2"
                              >
                                {prop.proposal}
                              </label>
                            </div>
                          ))}
                      </div>
                    ))}
                  </div>

                  <div className="form__item flex justify-content-center w-full">
                    <button type="submit" disabled={loading}>
                      Terminer{" "}
                      <ProgressSpinner
                        style={
                          loading
                            ? { width: "20px", height: "20px" }
                            : { width: "0px", height: "0px" }
                        }
                        strokeWidth="8"
                        loading={loading}
                      />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Application;
